import _ from 'lodash';
import { Request } from  'common/domain/models/request';
import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';
import { EXCLUSIVE } from './teamRequestsFilters/teamRequestsFilters.constants';
import { HIDE_DETAIL } from './teamRequestCard/teamRequestCardDetails/teamRequestCardDetails.constants';

class TeamRequestsListController {
  constructor(
    EventEmitter,
    $filter,
    $scope,
    HelperDelegationsService,
    $rootScope
  ) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.filter = $filter;
    this.currentFilters = [];
    this.employeeFilters = [];
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.helperDelegationsService = HelperDelegationsService;
    this.exclusiveFilters = {};
    this.exclusiveFilters[EXCLUSIVE.ALL] = true;
  }

  $onInit() {
    this.filters = [
      {
        name: Request.TYPES.VACATION,
        label: 'VACATIONS_ABSENCES.GENERAL.VACATIONS',
        type: Request.TYPES.VACATION,
      }, {
        name: Request.TYPES.ABSENCE,
        label: 'VACATIONS_ABSENCES.GENERAL.ABSENCES',
        type: Request.TYPES.ABSENCE,
      }, {
        name: Request.STATUS_REQUESTED.DISCARD,
        label: 'GLOBALS.NOTIFICATIONS',
        type: Request.STATUS_REQUESTED.DISCARD,
        icon: 'icon icon-bell',
      },
    ];

    this.floatingActionsButtons = this.getFloatingActionButtons();
  }

  isEmpty() {
    return isUndefinedOrNullOrEmpty(this.requests)  || this._hasNotFilteredResults();
  }

  isLoaded() {
    return this.loaded === true;
  }

  _hasNotFilteredResults() {
    let filtered = this.filter('filterRequests')(this.requests, this.currentFilters);
    filtered = this.filter('employeeFilter')(filtered, this.employeeFilters);
    return filtered.length === 0;
  }

  hasFilters(){
    return this.currentFilters.length > 0;
  }

  onSearch() {
    return this.helperDelegationsService.onSearchEmployeeDelegations(this.employees);
  }

  showFilterActions() {
    return this.employeeFilters.length > 0 || this.showApproveAll();
  }

  showApproveAll() {
    if (this.isDisabled) {
      return false;
    }

    const atLeastOneRequest = this.filteredRequests && this.filteredRequests.length > 0;
    const filteredByVacations = this.currentFilters.indexOf(Request.TYPES.VACATION) > -1;
    const notFilteredByAbsences = this.currentFilters.indexOf(Request.TYPES.ABSENCE) === -1;

    return atLeastOneRequest && filteredByVacations && notFilteredByAbsences;
  }

  onFilter($event) {
    this.scope.$broadcast(HIDE_DETAIL);
    this.currentFilters = $event.selectedFilters;
  }

  onSelectEmployee($event) {
    if (!this.employeeFilters.find(employee => employee.userId === $event.userId)) {
      this.employeeFilters.push(angular.copy($event));
    }
  }

  onRemoveEmployeeFilter($event) {
    _.remove(this.employeeFilters, filter => filter.userId === $event.userId);
  }

  onCleanEmployeeFilters() {
    this.employeeFilters = [];
  }

  getCardClass() {
    return {
      'shown-filter': this.showFilterActions(),
      'responsiveMobile': this.isMobileApp,
    };
  }

  removeCard() {
    this.scope.$broadcast(HIDE_DETAIL);
    this.onAction();
  }

  approveAll(filteredRequests) {
    this.onApproveAll(this.EventEmitter({ requests: filteredRequests }));
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'VACATIONS_ABSENCES.GENERAL.APPROVE_ALL',
      }
    ];
  }

  showFiltersMobile(){
    return this.isMobileApp && this.showFilters();
  }

  showFiltersDesktop(){
    return !this.isMobileApp && this.showFilterActions();
  }

  showFilters(){
    return this.showFilterActions() && this.showApproveAll();
  }
}

export default TeamRequestsListController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsList.controller.js